module.exports = __webpack_public_path__ + "static/media/Work-Sans-regular.7051c6c2.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/Work-Sans-regular/Work-Sans-regular.woff
// module id = 420
// module chunks = 0